import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Global } from './core/Global';

@Injectable()
export class MigrationService {
	public url: string = Global.url_seguros

	private _http = inject(HttpClient)

	getPoliciesByYear(year: number): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		return this._http.get(this.url + 'policies/year/' + year, { headers: headers })
	}

	getGroupsByPolicy(policyId: string): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		return this._http.get(this.url + 'groups/' + policyId, { headers: headers })
	}

	getAllGroups(year?: number): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		const params = year ? '?year=' + year : ''
		return this._http.get(this.url + 'groups' + params, { headers: headers })
	}

	previewGroup(policyCode: number, originGroupName: string): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		return this._http.get(this.url + 'migrate/groups/preview?policyCode=' + policyCode + '&originGroupName=' + encodeURIComponent(originGroupName), { headers: headers })
	}

	previewGroupRequests(originGroupName: string, periodFrom?: string): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		const period = periodFrom ? '&periodFrom=' + periodFrom : ''
		return this._http.get(this.url + 'migrate/groups/preview-requests?originGroupName=' + encodeURIComponent(originGroupName) + period, { headers: headers })
	}

	reassignGroupCharges(data: { policyCode: number; originGroupName: string; destinationGroupName: string; periodFrom?: string }): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		return this._http.post(this.url + 'migrate/groups/reassign/charges', data, { headers: headers })
	}

	reassignGroupRequests(data: { originGroupName: string; destinationGroupName: string; periodFrom?: string }): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
		return this._http.post(this.url + 'migrate/groups/reassign/requests', data, { headers: headers })
	}
}
